module.exports = __webpack_public_path__ + "static/media/zuschuesse.e1b971b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/zuschuesse.svg
// module id = 911
// module chunks = 0